import { Badge } from "@thilke/ui/components/badge";
import { ScrollArea } from "@thilke/ui/components/scroll-area";
import { cn } from "@thilke/ui/lib/utils";
import type * as React from "react";

function ServerLogBlock({
  className,
  ...props
}: React.ComponentProps<"section">) {
  const rows = [
    { id: "build", level: "info", message: "registry build completed" },
    { id: "chunk", level: "warn", message: "chunk size above threshold" },
    {
      id: "upload",
      level: "info",
      message: "cloudflare pages upload complete",
    },
    { id: "cache", level: "debug", message: "cache hit: 69 files" },
  ];
  return (
    <section
      data-slot="server-log-block"
      className={cn("rounded-lg border bg-card p-3", className)}
      {...props}
    >
      <div className="mb-2 flex items-center justify-between gap-2">
        <div>
          <h3 className="text-sm font-semibold">Server logs</h3>
          <p className="text-xs text-muted-foreground">
            Service and application event streams.
          </p>
        </div>
        <Badge variant="outline">live</Badge>
      </div>
      <ScrollArea className="h-44 rounded-md bg-background p-3 font-mono text-xs">
        <div className="grid gap-1">
          {rows.map((row) => (
            <div key={row.id} className="grid grid-cols-[52px_1fr] gap-2">
              <span
                className={cn(
                  "uppercase",
                  row.level === "warn"
                    ? "text-warning"
                    : "text-muted-foreground",
                )}
              >
                {row.level}
              </span>
              <span>{row.message}</span>
            </div>
          ))}
        </div>
      </ScrollArea>
    </section>
  );
}

export { ServerLogBlock };
